import { EleveCommandes } from 'graphql/generated/graphql';

export const filterOrdersByPaymentStatus = (
  orders: EleveCommandes[],
  orderFilterValue: string
) =>
  orders.filter(order => {
    if (orderFilterValue === 'unPayed') {
      return order.status !== 'PAYE' && order.status !== 'ANNULE';
    } else if (orderFilterValue === 'payed') {
      return order.status === 'PAYE';
    } else if (orderFilterValue === 'canceled') {
      return order.status === 'ANNULE';
    } else {
      return true;
    }
  });
